import ReactRailsUJS from 'react_ujs'
import JobDashboard from '../components/JobDashboard'
import JobApplicationList from '../components/JobApplicationList'
import DemoApplicantBoard from '../components/DemoApplicantBoard'
import ProfileVideoRecorder from '../components/ProfileVideoRecorder'

const components = {
  JobDashboard,
  JobApplicationList,
  DemoApplicantBoard,
  ProfileVideoRecorder,
}

const requireContext = (key) => {
  const name = key.replace(/^\.\//, '')
  const component = components[name]

  if (!component) {
    throw new Error(`Unknown React component: ${key}`)
  }

  return { __esModule: true, default: component }
}

ReactRailsUJS.useContext(requireContext)
ReactRailsUJS.mountComponents()

function initAccountForm() {
  const photo = document.querySelector('[data-account-photo]')
  if (photo && !photo.dataset.bound) {
    photo.dataset.bound = 'true'
    const input = photo.querySelector('[data-photo-input]')
    const preview = photo.querySelector('[data-photo-preview]')
    const placeholder = photo.querySelector('[data-photo-placeholder]')
    const label = photo.querySelector('[data-photo-label]')

    if (input && preview) {
      input.addEventListener('change', () => {
        const file = input.files && input.files[0]
        if (!file || !file.type.startsWith('image/')) return
        preview.src = URL.createObjectURL(file)
        preview.hidden = false
        if (placeholder) placeholder.hidden = true
        if (label) label.textContent = 'Change photo'
      })
    }
  }

  const password = document.querySelector('[data-account-password]')
  if (password && !password.dataset.bound) {
    password.dataset.bound = 'true'
    const toggle = password.querySelector('[data-password-toggle]')
    const cancel = password.querySelector('[data-password-cancel]')
    const fields = password.querySelector('[data-password-fields]')
    const inputs = password.querySelectorAll('[data-password-field]')

    const setOpen = (open) => {
      if (fields) fields.hidden = !open
      if (toggle) toggle.hidden = open
      inputs.forEach((input) => {
        input.disabled = !open
        if (!open) input.value = ''
      })
      if (open && inputs[0]) inputs[0].focus()
    }

    if (toggle) toggle.addEventListener('click', () => setOpen(true))
    if (cancel) cancel.addEventListener('click', () => setOpen(false))
  }
}

function initCopyButtons() {
  document.querySelectorAll('[data-copy]').forEach((btn) => {
    if (btn.dataset.copyBound) return
    btn.dataset.copyBound = 'true'

    btn.addEventListener('click', async () => {
      const value = btn.dataset.copy
      try {
        await navigator.clipboard.writeText(value)
      } catch (e) {
        const input = document.createElement('input')
        input.value = value
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        input.remove()
      }

      const original = btn.innerHTML
      const labels = btn.querySelectorAll('.profile-share__label')
      if (labels.length) {
        const originals = Array.from(labels).map((label) => label.textContent)
        labels.forEach((label) => { label.textContent = 'Copied' })
        btn.classList.add('is-copied')
        setTimeout(() => {
          labels.forEach((label, index) => { label.textContent = originals[index] })
          btn.classList.remove('is-copied')
        }, 1600)
      } else {
        btn.textContent = 'Copied'
        btn.classList.add('is-copied')
        setTimeout(() => {
          btn.innerHTML = original
          btn.classList.remove('is-copied')
        }, 1600)
      }
    })
  })
}

document.addEventListener("turbolinks:load", function() {
  const cityPrompt = $('#city-prompt-modal');

  if (cityPrompt.length) {
    cityPrompt.modal('show');
  }

  initCopyButtons()
  initAccountForm()
})
